export class ReceivablesSummaryReq{
    fromDate?:any
    toDate?:any
    constructor(
        fromDate?:any,
        toDate?:any
    ){
    this.fromDate = fromDate
    this.toDate = toDate
    }
}

export class ReceivablesDetailsReq{
    year:string
    constructor(
        year:string
    ){
    this.year = year
    }
}